/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CrossCompanyMoveFolderContentsResultCto } from '../models/cross-company-move-folder-contents-result-cto';
import { moveFolderContents$Json } from '../fn/cross-company-folder/move-folder-contents-json';
import { MoveFolderContents$Json$Params } from '../fn/cross-company-folder/move-folder-contents-json';
import { moveFolderContents$Plain } from '../fn/cross-company-folder/move-folder-contents-plain';
import { MoveFolderContents$Plain$Params } from '../fn/cross-company-folder/move-folder-contents-plain';

@Injectable({ providedIn: 'root' })
export class CrossCompanyFolderService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `moveFolderContents()` */
  static readonly MoveFolderContentsPath = '/crosscompanyfolder/movefoldercontents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `moveFolderContents$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  moveFolderContents$Plain$Response(params?: MoveFolderContents$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CrossCompanyMoveFolderContentsResultCto>> {
    return moveFolderContents$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `moveFolderContents$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  moveFolderContents$Plain(params?: MoveFolderContents$Plain$Params, context?: HttpContext): Observable<CrossCompanyMoveFolderContentsResultCto> {
    return this.moveFolderContents$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CrossCompanyMoveFolderContentsResultCto>): CrossCompanyMoveFolderContentsResultCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `moveFolderContents$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  moveFolderContents$Json$Response(params?: MoveFolderContents$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CrossCompanyMoveFolderContentsResultCto>> {
    return moveFolderContents$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `moveFolderContents$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  moveFolderContents$Json(params?: MoveFolderContents$Json$Params, context?: HttpContext): Observable<CrossCompanyMoveFolderContentsResultCto> {
    return this.moveFolderContents$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CrossCompanyMoveFolderContentsResultCto>): CrossCompanyMoveFolderContentsResultCto => r.body)
    );
  }

}
